<!--
  StorefrontBanner.vue -- the storefront's single full-bleed banner geometry
  (GH-3633, Jake 2026-10-22: "match the home banner").

  The home page's hero renders a banner-shaped slide as a FULL-BLEED band
  (StorefrontHero, banner mode): edge to edge, no width cap, the image fills
  the width, height capped at HERO_BANNER_MAX_HEIGHT, and object-fit: contain
  so once the cap binds the leftover space becomes MARGIN AT THE SIDES, never
  a crop. The category page header now renders through this component with
  exactly that geometry. A category banner is ONE image, so unlike the hero
  no @load measurement is needed: width 100% + height auto lets the browser
  size the box from the image, and max-height + contain handle the cap.

  Full-bleed is achieved by NOT sitting inside .sf-container (the caller
  mounts this outside the width-capped body) and by width: 100% of the
  containing block, never 100vw (100vw includes the scrollbar gutter and
  induces a horizontal scrollbar).

  Contract: src (already resolved URL), alt (plain text), optional
  imageTestid for the <img>. The band carries data-testid="storefront-banner".
-->
<template>
  <div class="storefront-banner" data-testid="storefront-banner">
    <img
      class="storefront-banner__image"
      :src="src"
      :alt="alt"
      :style="imageStyle"
      :data-testid="imageTestid || undefined"
    />
  </div>
</template>

<script>
import { HERO_BANNER_MAX_HEIGHT } from "@/utils/heroCarouselLayout";

export default {
  name: "StorefrontBanner",

  props: {
    src: { type: String, required: true },
    alt: { type: String, default: "" },
    imageTestid: { type: String, default: "" },
  },

  computed: {
    // Bound inline (not scoped CSS) so the cap reads the SAME constant as
    // StorefrontHero's banner mode.
    imageStyle() {
      return {
        width: "100%",
        height: "auto",
        maxHeight: `${HERO_BANNER_MAX_HEIGHT}px`,
        objectFit: "contain",
      };
    },
  },
};
</script>

<style scoped>
/* Same surface as the hero band, so the side margins that appear when the
   height cap binds read as the band, as they do on the home page. */
.storefront-banner {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  background: var(--tf-surface-light, #f5f8fa);
}

.storefront-banner__image {
  display: block;
  margin: 0 auto;
}
</style>
